<template>
    <modal
        name="asiento-ocupado"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="asiento-ocupado"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div v-if="mostrar_error_personalizado"  class="col-10">
                        <h2 class="text-dark">{{ $t('partido.asiento_ocupado_content_error_maximo_entradas_title') }}</h2>
                    </div>
                    <div v-else class="col-10">
                        <h2 class="text-dark">{{ $t('partido.asiento_ocupado_title') }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="mostrar_error_personalizado" class="card-body">
                <p style="font-size: 20px;">{{ $t('partido.asiento_ocupado_content_error_maximo_entradas') }}</p>
            </div>
            <div v-else class="card-body">
                <p style="font-size: 20px;">{{ $t('partido.asiento_ocupado_content') }}</p>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{$t('partido.continuar')}}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        props: {
            mostrar_error_personalizado: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        },
    }

</script>
